import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService, TranslationChangeEvent } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ListaBase } from './../../../shared/crud/ListaBase';
import { FormatarData } from './../../../shared/formatarData';
import { RetornoSelecao } from './../../../shared/gridview/RetornoSelecao';
import { Estado } from './../../../shared/shared/estado.enum';
import { FiltroDealers } from './curva-abc-filtro/filtro-dealer';
import { CurvaAbcFiltroService } from './curva-abc-filtro/curva-abc-filtro.service';
import { CurvaAbcService } from './curva-abc-service/curva-abc.service';

declare var $: any;

@Component({
  selector: 'app-curva-abc',
  templateUrl: './curva-abc.component.html',
  styleUrls: ['./curva-abc.component.css']
})
export class CurvaAbcComponent extends ListaBase implements OnInit {
  selecionado: object;
  state: Estado = Estado.view;
  filtros: any = {};
  selecionados = [];
  parametrosFiltro: any;
  InicialData; // Set the first Day of month
  FinalData; // set the last day of query
  carregando = true;
  filtroDealers: FiltroDealers;
  modalTexto: string = 'Selecione os Dealers';

  constructor(private route: ActivatedRoute,
    private servico: CurvaAbcFiltroService,
    service: CurvaAbcService,
    toast: ToastrService,
    router: Router,
    private translate: TranslateService) { 
    super(service, toast, router);
      this.route.queryParams.subscribe(params => {
      this.parametrosFiltro = params;
      this.setaValorData(params['data_inicial'], params['data_final']);  
      this.carregarFiltrosParametros();
      this.filtroDealers = new FiltroDealers(this.servico);
    });
  }

  ngOnInit(): void {
    this.getTranslate();
    this.filtroDealers.carregar();
  }

  setaValorData(dataInicial: Date, dataFinal: Date) {
    const dt = new Date();
    if (dataInicial === undefined || dataInicial.toString() === '') {
      const dt = new Date();
      const dataInicial = { 'year': dt.getFullYear() - 1, 'month': dt.getMonth() + 1, 'day': dt.getUTCDate() + 1 };
      const dataInicialFormata = new FormatarData(dataInicial.year, dataInicial.month, dataInicial.day, 0, 0, 0).getDataString();
      this.InicialData = dataInicialFormata;
    } else {
      const now = new Date(dataInicial);
      this.InicialData = now.getFullYear() - 1 + '-' + ("0" + (now.getMonth() + 1)).slice(-2) + '-' + ("0" + (now.getUTCDate() + 1)).slice(-2);
    }

    if (dataFinal === undefined || dataFinal.toString() === '') {
      const dataFinal = { 'year': dt.getFullYear(), 'month': dt.getMonth() + 1, 'day': dt.getUTCDate()};
      const dataFinalFormata = new FormatarData(dataFinal.year, dataFinal.month, dataFinal.day, 0, 0, 0).getDataString();
      this.FinalData = dataFinalFormata;
    } else {
      const now = new Date(dataFinal);
      this.FinalData = now.getFullYear() + '-' + ("0" + (now.getMonth() + 1)).slice(-2) + '-' + ("0" + (now.getUTCDate())).slice(-2);
    }

    this.filtros = { data_inicial: this.InicialData, data_final: this.FinalData };
  }

  carregarFiltrosParametros() {
    if (this.parametrosFiltro) {
      for (const item in this.parametrosFiltro) {
        if (this.parametrosFiltro.hasOwnProperty(item)) {

          this.filtros[item] = this.parametrosFiltro[item];
        }
      }
    }
  }

  public getListagemComFiltros(): boolean {
    return this.filtros.data_inicial
      || this.filtros.data_final;
  }

  selecionarDealer() {
    $('#modal-dealers').modal();
  }

  removerDealer(dealer: any) {
    dealer.selecionado = false;
  }

  onAdicionarDealerFiltro(dealer: any) {
    dealer.selecionado = true;
  }

  filtrar() {
    return this.selecionados;
  }

  pesquisar() {
    this.selecionados = [];
    const sel = [];
    this.incluirFiltroDealers(sel);
    this.carregarFiltrosEspecificos(sel);

    this.selecionados = sel;
  }

  carregarFiltrosEspecificos(sel: any[]) {
    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        const item = {'chave': chave, 'valor': this.filtros[chave]};
        sel.push(item);
      }
    }
  }

  private incluirFiltroDealers(filtros: any[]) {
    if (this.filtroDealers.selecionados().length > 0) {
      const item = { 'chave': 'dealers', 'valor': [] };
      this.filtroDealers.selecionados().forEach(element => {
        item.valor.push(element.id);
      });
      filtros.push(item);
    }
  }

  private getTranslate() {
    this.translate.onLangChange
      .subscribe((event: TranslationChangeEvent) => {

        if (event.lang === 'br') {
          this.modalTexto = 'Selecione os Dealers';
        }

        if (event.lang === 'gb') {
          this.modalTexto = 'Select Dealers';
        }
    });
  }

  selecionar(selecionado: RetornoSelecao) {
    this.selecionado = selecionado.registro;
  }

}
